import React, {useEffect} from 'react';
import { Text, View ,StyleSheet,BackHandler, TouchableOpacity} from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons'; 
import { EvilIcons } from '@expo/vector-icons'; 
import { AntDesign } from '@expo/vector-icons';
import { MaterialIcons } from '@expo/vector-icons';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import Swal from 'sweetalert2'; 
 
export default function logado({route,navigation}){


    useEffect(() => {
      const backAction = () => {
        Alert.alert('Hold on!', 'Are you sure you want to go back?', [
          {
            text: 'Cancel',
            onPress: () => null,
            style: 'cancel',
          },
          { text: 'YES', onPress: () => BackHandler.exitApp() },
        ]);
        return true;
      };
  
      const backHandler = BackHandler.addEventListener('hardwareBackPress', backAction);
  
      return () => backHandler.remove();
    }, []);
      return (
<View style={{flex:1,margin:10}}>
<View style={{backgroundColor:'#01150E',height:160,width:'100%',borderRadius:16,marginRight:10}}> 
{/*começa cabeçario*/}
     <View style={{flexDirection:'row',justifyContent:'space-between'}}>
     <Text style={{margin:20, color:'white',fontSize:17}}>{route.params.nome}</Text>
     <View style={{margin:20,color:'white'}}>
     <Text style={{fontSize:17,color:'white'}}>Bem vindo</Text>
     </View>
     </View>
    <View style={{flexDirection:'row',justifyContent:'space-between'}}>
    <View style={{alignItems:'flex-start'}}>
     <View style={{marginTop:30,marginLeft:20,height:80,alignItems:'center',flexShrink:1}}>
       <TouchableOpacity>
       <FontAwesome5 onPress = {() => {navigation.navigate('dadosbancarios',{id:route.params.id,userid:route.params.userid})}} name="piggy-bank" size={30} color="white" />
       </TouchableOpacity>
      
      <Text style={{color:'white'}}>Dados Bancários</Text>
      </View>
     </View>
     <View style={{alignItems:'flex-start'}}>
     <View style={{marginTop:30,marginRight:20,height:80,alignItems:'center',flexShrink:1}}>
    <TouchableOpacity>
    <FontAwesome5 onPress = {() => {navigation.navigate('dadospessoais',{id:route.params.id,userid:route.params.userid})}} name="user-edit" size={30} color="white" />
    </TouchableOpacity>
     
      <Text style={{color:'white'}}>Dados pessoais</Text>
      </View>
     </View>
    </View>
    {/*Termina cabeçario*/}
    {/*começa cabeçario*/}
    <View style={{backgroundColor:'#01150E',height:160,width:'100%',borderRadius:16,marginBottom:10}}>
    <View style={{flexDirection:'row',justifyContent:'space-between'}}>
     <Text style={{margin:20, color:'white',fontSize:17}}>Cadastrar Cartão</Text>
     <View style={{margin:20,color:'white'}}>
     <Text style={{fontSize:17,color:'white',}}>Sacar saldo</Text>
     </View>
     </View>
    <View style={{flexDirection:'row',justifyContent:'space-between'}}>
    <View style={{alignItems:'flex-start'}}>
     <View style={{marginTop:30,marginLeft:15,height:80,alignItems:'center',flexShrink:1}}>
      <TouchableOpacity>
      <FontAwesome5 onPress = {() => {
      navigation.navigate('DadosCartao',{id:route.params.id,userid:route.params.userid})
      }} name="address-card" size={30} color="white" />
      </TouchableOpacity>
      <Text style={{color:'white'}}>Dados do Cartão</Text>
     
      </View>
     </View>
     <View style={{alignItems:'flex-start'}}>
     <View style={{marginTop:30,marginRight:20,height:80,alignItems:'center',flexShrink:1}}>
     <TouchableOpacity>
      <EvilIcons onPress = {() => {navigation.navigate('ValorTrocar',{id:route.params.id,userid:route.params.userid})}} name="credit-card" size={35} color="white" />
     </TouchableOpacity>
      <Text style={{color:'white'}}>Sacar o saldo</Text>
      </View>
     </View>
    </View>
    </View>
    {/*Termina cabeçario*/} 
     {/*começa cabeçario*/}
    <View style={{backgroundColor:'#01150E',height:160,width:'100%',borderRadius:16,marginBottom:10}}>
    <View style={{flexDirection:'row',justifyContent:'space-between'}}>
     <Text style={{margin:20, color:'white',fontSize:17,marginRight:20}}>Trocas</Text>
     <View style={{margin:20,color:'white'}}>
     <Text style={{fontSize:17,color:'white',marginRight:20}}>Cartão.</Text>
     </View>
     </View>
    <View style={{flexDirection:'row',justifyContent:'space-between'}}>
    <View style={{alignItems:'flex-start'}}>
     <View style={{marginTop:30,marginLeft:20,height:80,alignItems:'center',flexShrink:1}}>
      <TouchableOpacity>
      <MaterialIcons name="attach-money" size={30} color="white"  onPress = {() => {navigation.navigate('contas',{id:route.params.id,userid:route.params.userid})}}/>
      </TouchableOpacity>
      <Text style={{color:'white'}}>Relatórios</Text>
     
      </View>
     </View>
     <View style={{alignItems:'flex-start',marginRight:10}}>
     <View style={{marginTop:30,marginRight:20,height:80,alignItems:'center',flexShrink:1}}>
     <TouchableOpacity>
      
    
     </TouchableOpacity>
     <MaterialCommunityIcons name="food-fork-drink" size={35} color="white"  
     onPress = {() => 
      {//navigation.navigate('voucher',{id:route.params.id,userid:route.params.userid})
         {/*Aviso nao habilidade*/}
         Swal.fire({
          title: 'Funcão não habilitada nesse momento',
          text: "Avisaremos quando esse serviço estiver disponível",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK!'
        })
        {/*Fim aviso */}

      
      }}/>
      <Text style={{color:'white'}}  >Alimentação</Text>
      </View>
     </View>
    </View>
    </View>
    {/*Termina cabeçario*/}

     {/*começa cabeçario*/}
     <View style={{backgroundColor:'#01150E',height:160,width:'100%',borderRadius:16,marginBottom:10}}>
    <View style={{flexDirection:'row',justifyContent:'space-between'}}>
     <Text style={{margin:20, color:'white',fontSize:17}}>Suporte</Text>
     <View style={{margin:20,color:'white'}}>
     <Text style={{fontSize:17,color:'white',marginRight:10}}>Dúvidas</Text>
     </View>
     </View>
    <View style={{flexDirection:'row',justifyContent:'space-between'}}>
    <View style={{alignItems:'flex-start'}}>
     <View style={{marginTop:30,marginLeft:20,height:80,alignItems:'center',flexShrink:1}}>
      <TouchableOpacity>
      <a style={{textDecorationLine:'none'}} href='https://api.​whatsapp.com/send?phone=5531998654033&text=Preciso de ajuda'>
      <FontAwesome5 name="whatsapp" size={30} color="white"/>
      </a>
      </TouchableOpacity>
      <Text style={{color:'white'}}>Whatsapp</Text>
     
      </View>
     </View>
     <View style={{alignItems:'flex-start',marginRight:10}}>
     <View style={{marginTop:30,marginRight:20,height:80,alignItems:'center',flexShrink:1}}>
     <TouchableOpacity>
      
      <AntDesign  onPress = {() => {navigation.navigate('duvidas',{id:route.params.id})}} name="questioncircleo" size={30} color="white" />
     </TouchableOpacity>
      <Text style={{color:'white'}}>Dúvidas</Text>
      </View>
     </View>
    </View>
    </View>
    {/*Termina cabeçario*/} 
     </View>
</View>
  );
}

const styles = StyleSheet.create({
  input: {
          
    
  },


  
});